exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-interest-investor-___style__taxId___3E3K5>input{display:inline;-moz-appearance:textfield}.web-flows-interest-investor-___style__taxId___3E3K5>input::-webkit-inner-spin-button,.web-flows-interest-investor-___style__taxId___3E3K5>input::-webkit-outer-spin-button{-webkit-appearance:none}.web-flows-interest-investor-___style__address___3BsAa>input{display:block;margin:.5em 0;width:50%}.web-flows-interest-investor-___style__address___3BsAa>input:first-child{margin-top:0}@media (min-width:600px) and (max-width:959px){.web-flows-interest-investor-___style__address___3BsAa>input{width:60%}}@media (max-width:599px){.web-flows-interest-investor-___style__address___3BsAa>input{width:100%}}.web-flows-interest-investor-___style__taxId___3E3K5>span{padding:0 .5em}.web-flows-interest-investor-___style__formlabel___3MlrX{display:block;padding:.4em 0}.web-flows-interest-investor-___style__note___QC-Py{font-size:.8em;color:#95989a}", ""]);

// exports
exports.locals = {
	"taxId": "web-flows-interest-investor-___style__taxId___3E3K5",
	"address": "web-flows-interest-investor-___style__address___3BsAa",
	"formlabel": "web-flows-interest-investor-___style__formlabel___3MlrX",
	"note": "web-flows-interest-investor-___style__note___QC-Py"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/interest/investor/style.css
// module id = 1356
// module chunks = 0